import React from 'react';
import './App.css';
import Route from './app/route';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
      <React.Fragment>
        <Route />
      </React.Fragment>
  );
}

export default App;
